import React, { useState, useEffect } from 'react';
import { getComplaints, replyComplaint } from '../../api';
import { toast } from 'react-toastify';

const ViewComplaints = () => {
  const [complaints, setComplaints] = useState([]);
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [reply, setReply] = useState('');
  const [status, setStatus] = useState('reviewed');

  useEffect(() => { loadComplaints(); }, []);

  const loadComplaints = async () => {
    try {
      const res = await getComplaints();
      setComplaints(res.data);
    } catch (err) {
      toast.error('Error loading complaints');
    }
  };

  const handleReply = async (id) => {
    try {
      await replyComplaint(id, { admin_reply: reply, status });
      toast.success('Reply sent!');
      setSelectedComplaint(null);
      setReply('');
      loadComplaints();
    } catch (err) {
      toast.error('Error sending reply');
    }
  };

  const getStatusColor = (status) => {
    if (status === 'pending') return { bg: '#fff3cd', color: '#856404' };
    if (status === 'reviewed') return { bg: '#cce5ff', color: '#004085' };
    return { bg: '#d4edda', color: '#155724' };
  };

  return (
    <div>
      <h3 style={styles.title}>📝 Student Complaints</h3>

      {complaints.length === 0 && (
        <div style={styles.empty}>No complaints received yet!</div>
      )}

      {complaints.map(c => (
        <div key={c.id} style={styles.complaintCard}>
          <div style={styles.complaintHeader}>
            <div>
              <h4 style={styles.complaintTitle}>{c.subject}</h4>
              <p style={styles.studentName}>By: {c.student_name}</p>
            </div>
            <div style={styles.rightSide}>
              <span style={{
                ...styles.badge,
                background: getStatusColor(c.status).bg,
                color: getStatusColor(c.status).color
              }}>
                {c.status}
              </span>
              <p style={styles.date}>
                {new Date(c.created_at).toLocaleDateString()}
              </p>
            </div>
          </div>

          <p style={styles.complaintText}>{c.description}</p>

          {c.admin_reply && (
            <div style={styles.replyBox}>
              <p style={styles.replyLabel}>Admin Reply:</p>
              <p style={styles.replyText}>{c.admin_reply}</p>
            </div>
          )}

          {selectedComplaint === c.id ? (
            <div style={styles.replyForm}>
              <textarea
                style={styles.textarea}
                placeholder="Write your reply..."
                value={reply}
                rows={3}
                onChange={e => setReply(e.target.value)}
              />
              <select style={styles.select} value={status}
                onChange={e => setStatus(e.target.value)}>
                <option value="reviewed">Reviewed</option>
                <option value="resolved">Resolved</option>
              </select>
              <div style={styles.btnGroup}>
                <button style={styles.replyBtn}
                  onClick={() => handleReply(c.id)}>Send Reply</button>
                <button style={styles.cancelBtn}
                  onClick={() => setSelectedComplaint(null)}>Cancel</button>
              </div>
            </div>
          ) : (
            <button style={styles.replyBtn}
              onClick={() => setSelectedComplaint(c.id)}>
              {c.admin_reply ? 'Update Reply' : 'Reply'}
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

const styles = {
  title: { color: '#1a3a5c', marginBottom: '20px' },
  empty: { textAlign: 'center', color: '#999', padding: '40px', background: 'white', borderRadius: '12px' },
  complaintCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '15px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  complaintHeader: { display: 'flex', justifyContent: 'space-between', marginBottom: '10px' },
  complaintTitle: { color: '#1a3a5c', margin: '0 0 5px', fontSize: '16px' },
  studentName: { color: '#666', fontSize: '13px', margin: 0 },
  rightSide: { textAlign: 'right' },
  badge: { padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' },
  date: { color: '#999', fontSize: '12px', margin: '5px 0 0' },
  complaintText: { color: '#444', fontSize: '14px', lineHeight: '1.6', margin: '0 0 15px' },
  replyBox: { background: '#e8f4fd', borderRadius: '8px', padding: '12px', marginBottom: '15px' },
  replyLabel: { color: '#0d6efd', fontSize: '12px', fontWeight: '600', margin: '0 0 5px' },
  replyText: { color: '#444', fontSize: '13px', margin: 0 },
  replyForm: { display: 'flex', flexDirection: 'column', gap: '10px' },
  textarea: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', resize: 'vertical' },
  select: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' },
  btnGroup: { display: 'flex', gap: '10px' },
  replyBtn: { padding: '8px 20px', background: '#0d6efd', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  cancelBtn: { padding: '8px 20px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
};

export default ViewComplaints;